
import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/blog/archive',
    component: ComponentCreator('/blog/archive','f4c'),
    exact: true
  },
  {
    path: '/docs/tags',
    component: ComponentCreator('/docs/tags','0cc'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs','f38'),
    routes: [
      {
        path: '/docs/api-reference/authentication',
        component: ComponentCreator('/docs/api-reference/authentication','358'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/client',
        component: ComponentCreator('/docs/api-reference/client','16c'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/config',
        component: ComponentCreator('/docs/api-reference/config','032'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events-and-actions',
        component: ComponentCreator('/docs/api-reference/events-and-actions','be8'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/agency-of-record-changed',
        component: ComponentCreator('/docs/api-reference/events/agency-of-record-changed','b25'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/billing-inquiry',
        component: ComponentCreator('/docs/api-reference/events/billing-inquiry','e32'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/billing-invoice-cancelled',
        component: ComponentCreator('/docs/api-reference/events/billing-invoice-cancelled','be2'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/billing-invoice-created',
        component: ComponentCreator('/docs/api-reference/events/billing-invoice-created','60b'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/billing-invoice-paid',
        component: ComponentCreator('/docs/api-reference/events/billing-invoice-paid','cee'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/billing-plan-change',
        component: ComponentCreator('/docs/api-reference/events/billing-plan-change','aae'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-adjusted',
        component: ComponentCreator('/docs/api-reference/events/claim-adjusted','975'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-adjuster-assigned',
        component: ComponentCreator('/docs/api-reference/events/claim-adjuster-assigned','df1'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-approved',
        component: ComponentCreator('/docs/api-reference/events/claim-approved','d1c'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-changed',
        component: ComponentCreator('/docs/api-reference/events/claim-changed','a2f'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-denied',
        component: ComponentCreator('/docs/api-reference/events/claim-denied','e25'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-fnol',
        component: ComponentCreator('/docs/api-reference/events/claim-fnol','5f2'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-inquiry',
        component: ComponentCreator('/docs/api-reference/events/claim-inquiry','41b'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-notification',
        component: ComponentCreator('/docs/api-reference/events/claim-notification','929'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-paid',
        component: ComponentCreator('/docs/api-reference/events/claim-paid','8f4'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/claim-status-change',
        component: ComponentCreator('/docs/api-reference/events/claim-status-change','e6d'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/client-validation',
        component: ComponentCreator('/docs/api-reference/events/client-validation','785'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/client-validation-failed',
        component: ComponentCreator('/docs/api-reference/events/client-validation-failed','3a8'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-cert-request',
        component: ComponentCreator('/docs/api-reference/events/customer-cert-request','911'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-document',
        component: ComponentCreator('/docs/api-reference/events/customer-document','6b3'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-renewal-1-day-out',
        component: ComponentCreator('/docs/api-reference/events/customer-renewal-1-day-out','267'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-renewal-120-days-out',
        component: ComponentCreator('/docs/api-reference/events/customer-renewal-120-days-out','44d'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-renewal-30-days-out',
        component: ComponentCreator('/docs/api-reference/events/customer-renewal-30-days-out','139'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-renewal-60-days-out',
        component: ComponentCreator('/docs/api-reference/events/customer-renewal-60-days-out','2e3'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-renewal-7-days-out',
        component: ComponentCreator('/docs/api-reference/events/customer-renewal-7-days-out','007'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/customer-renewal-90-days-out',
        component: ComponentCreator('/docs/api-reference/events/customer-renewal-90-days-out','bbd'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-customer-credit',
        component: ComponentCreator('/docs/api-reference/events/finance-customer-credit','c0f'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-customer-debit',
        component: ComponentCreator('/docs/api-reference/events/finance-customer-debit','c09'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-dividend-credited',
        component: ComponentCreator('/docs/api-reference/events/finance-dividend-credited','c59'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-dividend-paid',
        component: ComponentCreator('/docs/api-reference/events/finance-dividend-paid','a43'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-recovery-payment',
        component: ComponentCreator('/docs/api-reference/events/finance-recovery-payment','93b'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-refund-approved',
        component: ComponentCreator('/docs/api-reference/events/finance-refund-approved','948'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-refund-paid',
        component: ComponentCreator('/docs/api-reference/events/finance-refund-paid','2a7'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/finance-refund-requested',
        component: ComponentCreator('/docs/api-reference/events/finance-refund-requested','339'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/get-quotes',
        component: ComponentCreator('/docs/api-reference/events/get-quotes','349'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/intake-complete',
        component: ComponentCreator('/docs/api-reference/events/intake-complete','461'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/payment-received',
        component: ComponentCreator('/docs/api-reference/events/payment-received','a3e'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/payment-setup',
        component: ComponentCreator('/docs/api-reference/events/payment-setup','0d9'),
        exact: true
      },
      {
        path: '/docs/api-reference/events/payment-verification',
        component: ComponentCreator('/docs/api-reference/events/payment-verification','78f'),
        exact: true
      },
      {
        path: '/docs/api-reference/events/policy-cancel',
        component: ComponentCreator('/docs/api-reference/events/policy-cancel','f59'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-created',
        component: ComponentCreator('/docs/api-reference/events/policy-created','d49'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-deductible-changed',
        component: ComponentCreator('/docs/api-reference/events/policy-deductible-changed','6e2'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-limit-changed',
        component: ComponentCreator('/docs/api-reference/events/policy-limit-changed','5cb'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-line-add',
        component: ComponentCreator('/docs/api-reference/events/policy-line-add','b0c'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-line-removed',
        component: ComponentCreator('/docs/api-reference/events/policy-line-removed','efa'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-notification',
        component: ComponentCreator('/docs/api-reference/events/policy-notification','31e'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-premium-changed',
        component: ComponentCreator('/docs/api-reference/events/policy-premium-changed','e25'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-reinstated',
        component: ComponentCreator('/docs/api-reference/events/policy-reinstated','d76'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-renewal-failed',
        component: ComponentCreator('/docs/api-reference/events/policy-renewal-failed','f28'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/policy-renewed',
        component: ComponentCreator('/docs/api-reference/events/policy-renewed','148'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/pre-policy-cancellation',
        component: ComponentCreator('/docs/api-reference/events/pre-policy-cancellation','9aa'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/select-quote',
        component: ComponentCreator('/docs/api-reference/events/select-quote','a20'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/statement-created',
        component: ComponentCreator('/docs/api-reference/events/statement-created','2c5'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/template',
        component: ComponentCreator('/docs/api-reference/events/template','8f2'),
        exact: true
      },
      {
        path: '/docs/api-reference/events/underwriting-approved',
        component: ComponentCreator('/docs/api-reference/events/underwriting-approved','d28'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/underwriting-declined',
        component: ComponentCreator('/docs/api-reference/events/underwriting-declined','a77'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/underwriting-referred',
        component: ComponentCreator('/docs/api-reference/events/underwriting-referred','e50'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/unit-of-exposure-added',
        component: ComponentCreator('/docs/api-reference/events/unit-of-exposure-added','5c9'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/unit-of-exposure-changed',
        component: ComponentCreator('/docs/api-reference/events/unit-of-exposure-changed','142'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/unit-of-exposure-removed',
        component: ComponentCreator('/docs/api-reference/events/unit-of-exposure-removed','628'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/events/webhook',
        component: ComponentCreator('/docs/api-reference/events/webhook','51a'),
        exact: true
      },
      {
        path: '/docs/api-reference/fire-event',
        component: ComponentCreator('/docs/api-reference/fire-event','2d8'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/product-and-questions',
        component: ComponentCreator('/docs/api-reference/product-and-questions','0bc'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/quotes',
        component: ComponentCreator('/docs/api-reference/quotes','219'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/api-reference/rules',
        component: ComponentCreator('/docs/api-reference/rules','044'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/getting-started/connecting-to-a-policy-service',
        component: ComponentCreator('/docs/getting-started/connecting-to-a-policy-service','84a'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/getting-started/getting-a-quote',
        component: ComponentCreator('/docs/getting-started/getting-a-quote','b07'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/integration-options',
        component: ComponentCreator('/docs/integration-options','cbe'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/start',
        component: ComponentCreator('/docs/start','b2f'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/webhooks/monitor-api-traffic',
        component: ComponentCreator('/docs/webhooks/monitor-api-traffic','7fc'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/webhooks/select-events',
        component: ComponentCreator('/docs/webhooks/select-events','b67'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/webhooks/setup-an-action',
        component: ComponentCreator('/docs/webhooks/setup-an-action','c89'),
        exact: true,
        'sidebar': "docs"
      },
      {
        path: '/docs/what-is-internet-of-insurance',
        component: ComponentCreator('/docs/what-is-internet-of-insurance','215'),
        exact: true
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*')
  }
];
